module.exports = __webpack_public_path__ + "img/marker-oil-refinery-green.31978712.png";